import { StackerPulpit } from "@/pages/stacker-pulpit";

export const routeStackerProduction = "/stacker-production";

export const stackerPulpitRoutes = [
	{
		path: `${routeStackerProduction}`,
		element: <StackerPulpit />,
		permission: "ui.navbar.mill.stacker.production",
	},
	{
		path: `${routeStackerProduction}/:shiftId`,
		element: <StackerPulpit />,
		permission: "ui.navbar.mill.stacker.production",
	},
];
